import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import Modal from '../../components/Modal';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Manipulator from '../../utils/dom/manipulator';

const KEY_OBJECT = "fieldName";
const VALUE_OBJECT = "value";

const CLICK_EVENT = 'click';

const IS_LOCAL = false;

const SELECTOR_WRAPPER = '.p-park-activator-sessions-venue';
const SELECTOR_ADD_PARK_BUTTON = '.p-park-activator-sessions-venue--add-park-button';
const SELECTOR_DATA_WRAPPER = '.p-park-activator-sessions-venue__data-wrapper';

const SELECTOR_PARK_FINDER_MODAL = '#park-finder-modal';
const SELECTOR_PARK_MODAL_BODY = '.lta-modal-body';
const SELECTOR_REMOVE_BUTTON = '.p-park-activator-sessions-venue--edit-park-button';

const STEPS = {
	"Steps": [
	{
	  "default": false,
	  "dependentQuestion": [],
	  "placeHolder": "Type park name or postcode to search",
	  "errorMessage": "Please select the name of your park",
	  "extraSubtitle": "Please provide the name and address for your park",
	  "fieldName": "park",
	  "id": 1,
	  "instructionText": "",
	  "label": "",
	  "options": [],
	  "question": "DELIVERING YOUR FREE PARKS TENNIS SESSIONS?",
	  "questionPrefix": "Where will you be",
	  "questionType": "parkFinder",
	  "step": 1,
	  "visible": true,
	  "hasLimit": true,
	  "charLimit": 3,
	  "minSearchChar": 3,
	  "isSkipButtonVisible": true,
	  "skipButtonTitle": "OK",
	  "resultTitleNotVisible": true
	}]
};
class ParkActivatorSessionsVenue {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() { 
        return this._stepsData; 
    }

    set stepsData(_stepsData) { 
        this._stepsData = _stepsData; 
		if(_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
    }

	init() {
		this.parkAddParkButton = SelectorEngine.findOne(SELECTOR_ADD_PARK_BUTTON, this._wrapper);
		this.parkFinderModalElement = SelectorEngine.findOne(SELECTOR_PARK_FINDER_MODAL, this._wrapper);
		this.parkFinderModalBody = SelectorEngine.findOne(SELECTOR_PARK_MODAL_BODY, this._wrapper);
		this.parkFinderModal = new Modal(this.parkFinderModalElement);

		this.parkFinderDataWrapper = SelectorEngine.findOne(SELECTOR_DATA_WRAPPER, this._wrapper);
		if (this.parkFinderDataWrapper) {
			this.parkFinderVenuesList = SelectorEngine.find(
				'.p-park-activator-sessions-venue--card',
				this.parkFinderDataWrapper
			);

			for (const parkVenue of this.parkFinderVenuesList) {
				const removeButton = SelectorEngine.findOne(SELECTOR_REMOVE_BUTTON, parkVenue);
				EventHandler.on(removeButton, CLICK_EVENT, () => {
					const venueID = Manipulator.getDataAttribute(parkVenue, 'affiliationId');
					const requestObject = {
						"affiliationId": venueID
					}
					this.removeParkActivatorVenue(requestObject);
				});
			}
		}
		EventHandler.on(this.parkAddParkButton, CLICK_EVENT, () => {
			this.parkFinderModal.show();
			this.stepsData = STEPS.Steps;
		});
	}

	initiateFormGenerator(stepsData) {
		if(this.formGenerator) {
			this.formGenerator.remove();
		}
		this.formGenerator = new FormGenerator(this.parkFinderModalBody, {
			questions: stepsData,
			totalSteps: 1,
			stepTitle: '',
			hasSeparator: false,
			isHideProgress: true,
			formType: FormTypes.StepForm,
		});
		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
			this.parkFinderModal.hide();
			this.addParkActivatorVenue(this.answerList);
		});
	}
	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				}
			}
		}
	}
	async addParkActivatorVenue(requestObject) {
		startLoadingAnimation();
		try { 
			const url = "/api/parksactivators/AddAffiliatedVenue";
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			 	}
			});
			const { Success, success, error } = response;
			stopLoadingAnimation();
			if(Success || success) {
				location.reload();
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
	async removeParkActivatorVenue(requestObject) {
		startLoadingAnimation();
		try { 
			const url = "/api/parksactivators/RemoveAffiliatedVenue";
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			 	}
			});
			const { Success, success, error } = response;
			stopLoadingAnimation();
			if(Success || success) {
				location.reload();
			}
			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
}

const globalParkActivatorSessionsVenue = new ParkActivatorSessionsVenue();
export default globalParkActivatorSessionsVenue;